export default function HoldingPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0A0E1A',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 32,
    }}>
      <img
        src="/produhkt-logo.jpg"
        alt="Produhkt"
        style={{ maxWidth: 320, width: '100%', marginBottom: 32 }}
      />
      <p style={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 300,
        fontSize: 18,
        color: '#FFFFFF',
        letterSpacing: '0.05em',
        textAlign: 'center',
        margin: 0,
      }}>
        One platform. One product journey.
      </p>
    </div>
  );
}
